import React, { useState } from 'react';

const VideoFrame = ({ videoUrl, thumbnailUrl, title, language = 'de', showTitle = true, thumbnailIndex }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [thumbIdx, setThumbIdx] = useState(0);

  const handlePlay = (e) => {
    e.stopPropagation();
    setIsPlaying(true);
  };

  const handleClose = () => {
    setIsPlaying(false);
  };

  const getYouTubeId = (url) => {
    let videoId = null;
    if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1].split('&')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1].split('?')[0];
    }
    if (videoId && videoId.length === 11) {
      return videoId;
    }
    return null;
  };

  const videoId = getYouTubeId(videoUrl);

  // Générer des candidats de miniatures (privilégier des images plus tardives 3,2,1,0)
  const buildThumbnailCandidates = () => {
    if (!videoId) return [];
    const laterFirst = [3, 2, 1, 0];
    const orderedIndices = typeof thumbnailIndex === 'number'
      ? [thumbnailIndex, ...laterFirst]
      : laterFirst;
    const uniqueIndices = Array.from(new Set(orderedIndices.filter((n) => n >= 0 && n <= 3)));
    const base = `https://img.youtube.com/vi/${videoId}`;
    const indexBased = uniqueIndices.map((n) => `${base}/${n}.jpg`);
    const qualityBased = [
      `${base}/maxresdefault.jpg`,
      `${base}/hqdefault.jpg`,
      `${base}/sddefault.jpg`,
      `${base}/mqdefault.jpg`,
    ];
    return [...qualityBased, ...indexBased];
  };

  const thumbnailCandidates = buildThumbnailCandidates();
  const resolvedThumbnailSrc = thumbnailUrl || thumbnailCandidates[thumbIdx] || '';

  const handleThumbError = () => {
    setThumbIdx((prev) => (prev + 1 < thumbnailCandidates.length ? prev + 1 : prev));
  };

  const handleThumbLoad = (e) => {
    const img = e?.target;
    if (!img) return;
    const isNumericThumb = /\/([0-3])\.jpg$/.test(img.src);
    const naturalWidth = img.naturalWidth || 0;
    // Si la miniature est trop petite (risque de flou en mise à l'échelle), passer à la suivante
    if (isNumericThumb && naturalWidth < 400 && thumbIdx + 1 < thumbnailCandidates.length) {
      setThumbIdx(thumbIdx + 1);
    }
  };

  if (isPlaying) {
    return (
      <div className="video-modal-overlay" onClick={handleClose}>
        <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="video-close-btn" onClick={handleClose}>X</button>
          <div className="video-container">
            {videoId ? (
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="video-iframe"
                loading="lazy"
              ></iframe>
            ) : (
              <div className="video-error">
                <p>Erreur: Impossible de charger la vidéo</p>
                <p>URL: {videoUrl}</p>
                <button onClick={() => window.open(videoUrl, '_blank')}>
                  Ouvrir dans YouTube
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="video-frame" onClick={handlePlay}>
      <div className="video-thumbnail">
        <img
          src={resolvedThumbnailSrc}
          alt={title}
          className="video-thumbnail-img"
          loading="lazy"
          onError={handleThumbError}
          onLoad={handleThumbLoad}
        />
        <div className="video-play-overlay">
          <div className="video-play-button">PLAY</div>
        </div>
      </div>
      {showTitle && <div className="video-frame-title">{title}</div>}
    </div>
  );
};

export default VideoFrame; 